import swal from "sweetalert";
import FIREBASE from "../config/FIREBASE";
import {
  dispatchError,
  dispatchLoading,
  dispatchSuccess,
} from "../utils/dispatch/index";

import { ADMINS_LOGIN, ADMINS_LOGOUT, API_TIMEOUT } from "../utils";
import axios from "axios";
import { API_ESA_OFFICE } from "utils";

// Konfigurasi axios global untuk mengirim credentials
axios.defaults.withCredentials = true;

export const LOGIN_USER = "LOGIN_USER";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// Hapus global flag untuk menyederhanakan

export const loginUser = (email, password, setLoginProses, navigate) => {
  console.log("🔥 Firebase auth started for:", email);
  FIREBASE.auth()
    .signInWithEmailAndPassword(email, password)
    .then((res) => {
      console.log("✅ Firebase auth successful, checking database");
      FIREBASE.database()
        .ref(`users/${res.user.uid}`)
        .once("value")
        .then((resDB) => {
          // Signed in
          if (resDB.val()) {
            console.log("📊 Database user found, checking ESA Office API");

            console.log("🔍 resDB.val().uid", resDB.val());
            //Pengecekan admin ke data base esa office
            axios({
              method: "get",
              url: `${API_ESA_OFFICE}users/uid/` + resDB.val().uid,
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true, // PENTING: Untuk mengirim cookies
            })
              .then((response) => {
                if (response.status !== 200) {
                  // ERROR
                } else {
                  //BERHASIL

                  const data = response.data.user;
                  const accessToken = response.data.accessToken; // Ambil accessToken dari response

                  //cek apakah yang bersangkutan terdata di sim obat
                  if (data.nama) {
                    //BERHASIL

                    const dataUser = resDB.val();
                    let curr = {};
                    curr.nama = data.nama;
                    curr.status = data.status;
                    curr.profil = data.profil;

                    curr.email = data.username;

                    curr.uid = data.user_id;
                    curr.uid_RSS = data.uid_RSS;
                    curr.dinas_id = data.dinas_id;
                    curr.bidang_id = data.bidang_id;
                    curr.unit_id = data.unit_id;
                    curr.jabatan = data.jabatan;
                    curr.level_jabatan = data.level_jabatan;
                    curr.jenis_unit = data.jenis_unit;
                    curr.pangkat = data.pangkat;
                    curr.nama_dinas = data.nama_dinas;
                    if (accessToken) {
                      curr.accessToken = accessToken; // Simpan accessToken
                    }
                    localStorage.setItem("user", JSON.stringify(curr));
                    console.log(
                      "✅ Login successful, user data saved to localStorage"
                    );

                    // Navigate langsung ke dashboard
                    console.log("🚀 Navigating to dashboard");
                    setLoginProses(false);

                    // Show success message and navigate
                    swal({
                      title: "Login Berhasil!",
                      text: `Selamat datang, ${data.nama}!`,
                      icon: "success",
                      button: "OK",
                      timer: 2000,
                    }).then(() => {
                      // return <Navigate to="/dashboards/analytics" replace />;
                      //"/dashboards/berita-terkini"
                      navigate("/dashboards/berita-terkini", {
                        replace: true,
                      });
                    });
                  } else {
                    setLoginProses(false);
                    swal({
                      title: "User Tidak Ditemukan",
                      text: "User tidak terdaftar di sistem ESA Office!",
                      icon: "error",
                      button: "OK",
                    });
                  }
                }
              })
              .catch((error) => {
                // ERROR
                console.error("❌ ESA Office API error:", error);
                setLoginProses(false);

                // Handle error khusus untuk status_EO tidak aktif
                if (error.response && error.response.status === 403) {
                  const errorData = error.response.data;
                  const errorMessage =
                    errorData.reason ||
                    errorData.message ||
                    "Akun Anda tidak aktif.";

                  swal({
                    title: "Akses Ditolak",
                    text: errorMessage,
                    icon: "error",
                    button: "OK",
                  });
                } else {
                  // Error lainnya
                  swal({
                    title: "Koneksi Gagal",
                    text:
                      error.response?.data?.message ||
                      "Tidak dapat terhubung ke server ESA Office. Silakan coba lagi!",
                    icon: "error",
                    button: "OK",
                  });
                }
              });

            //dispatchSuccess(dispatch, LOGIN_USER, resDB.val());
          } else {
            setLoginProses(false);
            swal({
              title: "Data User Tidak Valid",
              text: "Data user tidak ditemukan di Firebase. Silakan hubungi administrator!",
              icon: "error",
              button: "OK",
            });
          }
        })
        .catch((error) => {
          console.error("❌ Firebase database error:", error);
          setLoginProses(false);
          swal({
            title: "Database Error",
            text: "Terjadi kesalahan saat mengakses database. Silakan coba lagi!",
            icon: "error",
            button: "OK",
          });
        });
    })
    .catch((error) => {
      console.error("❌ Firebase auth error:", error.message);
      setLoginProses(false);

      // Handle specific Firebase auth errors
      let errorMessage = "Terjadi kesalahan saat login. Silakan coba lagi!";

      if (error.code === "auth/user-not-found") {
        errorMessage =
          "Email tidak terdaftar. Silakan periksa kembali email Anda!";
      } else if (error.code === "auth/wrong-password") {
        errorMessage = "Password salah. Silakan periksa kembali password Anda!";
      } else if (error.code === "auth/invalid-email") {
        errorMessage =
          "Format email tidak valid. Silakan periksa kembali email Anda!";
      } else if (error.code === "auth/too-many-requests") {
        errorMessage =
          "Terlalu banyak percobaan login. Silakan tunggu beberapa saat!";
      } else if (error.code === "auth/network-request-failed") {
        errorMessage =
          "Koneksi internet bermasalah. Silakan periksa koneksi Anda!";
      }

      swal({
        title: "Login Gagal",
        text: errorMessage,
        icon: "error",
        button: "OK",
      });
    });
};

export const loginUser2 = (email, password) => {
  return (dispatch) => {
    dispatchLoading(dispatch, LOGIN_USER);
    axios({
      method: "post",
      url: ADMINS_LOGIN,
      timeout: API_TIMEOUT,
      data: { username: email, password: password },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, LOGIN_USER, "error");
        } else {
          //BERHASIL
          if (response.data.success == 0) {
            dispatchError(dispatch, LOGIN_USER, "error");
          } else {
            dispatchSuccess(
              dispatch,
              LOGIN_USER,
              response.data.data ? response.data.data : []
            );
          }
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, LOGIN_USER, error);
      });
  };
};

export const checkLogin = (navigate) => {
  console.log("🔍 Checking login status...");
  const user = localStorage.getItem("user");

  if (user) {
    try {
      const userData = JSON.parse(user);
      console.log("✅ User found in localStorage:", userData.nama);
      navigate("/dashboards/analytics", { replace: true });
    } catch (error) {
      console.error("❌ Error parsing user data:", error);
      localStorage.removeItem("user");
      navigate("/authentication/sign-in/cover", { replace: true });
    }
  } else {
    console.log("❌ No user found in localStorage");
    navigate("/authentication/sign-in/cover", { replace: true });
  }
};

export function logoutUser(navigate) {
  // Konfirmasi sebelum logout
  swal({
    title: "Konfirmasi Logout",
    text: "Apakah Anda yakin ingin keluar dari sistem ESA Office?",
    icon: "warning",
    buttons: ["Batal", "Logout"],
    dangerMode: true,
  }).then((willLogout) => {
    if (!willLogout)
      //"/dashboards/berita-terkini"
      return navigate("/dashboards/berita-terkini", { replace: true });

    // Call backend logout endpoint untuk clear refresh token
    axios({
      method: "delete",
      url: `${API_ESA_OFFICE}users/logout`,
      withCredentials: true, // Kirim cookies untuk clear refresh token
    })
      .then((response) => {
        console.log("✅ Logout successful:", response.status);
      })
      .catch((error) => {
        console.log("gagalll keluar  ");
        console.error("❌ Logout error:", error);
      })
      .finally(() => {
        // Clear frontend data
        localStorage.removeItem("user");
        localStorage.removeItem("daftarHadir");
        localStorage.removeItem(
          "firebase:host:rotesmartservices-default-rtdb.firebaseio.com"
        );

        // Navigate to login page (gunakan navigate jika tersedia, jika tidak fallback ke window.location)
        if (typeof navigate === "function") {
          navigate("/authentication/sign-in/cover", { replace: true });
        } else if (typeof window !== "undefined") {
          window.location.href = "/authentication/sign-in/cover";
        }
      });

    return;
  });
}
